import { createSlice } from '@reduxjs/toolkit'


export const LANG_REDUCER_KEY = 'langPage'

const langSlice = createSlice({
    name: LANG_REDUCER_KEY,
    initialState: {
        lang: 'ru',
    },
    reducers: {
        selectLang: (state, { payload }) => {
            state.lang = payload
        },
    },
})

export const {
    selectLang,
} = langSlice.actions

const getState = state => state[LANG_REDUCER_KEY]
export const getIsLangRu = state => getState(state).lang === 'ru'

export default langSlice.reducer
